# Libraries
global.Vue = require 'vue'
global.Vuex = require 'vuex'
global.jQuery = require 'jquery'
global.alertify = require('alertify.js')()
alertify.delay(8000)

global.moment = require 'moment'
require('moment-timezone')
global.moment.tz.setDefault('America/Recife')

global.momentLocales = {
  pt_BR: require('./locales/moment-pt_BR.coffee'),
  en_US: require('moment/locale/en-gb'),
  es: require('moment/locale/es')
}

global.Locales = require './locales/pt_BR.coffee'
global.Cache = require './libraries/cache.coffee'
global.EventsBus = require './libraries/events_bus.coffee'

global.Tooltip = require './libraries/tooltip.coffee'
global.LinedTextarea = require './libraries/lined_textarea.coffee'
global.Loader = require './libraries/loader.coffee'
global.IntercomCtrl = require './libraries/intercom.coffee'
global.MixpanelCtrl = require './libraries/mixpanel.coffee'
global.Raphael = require 'raphael/raphael'
global.slugify = require 'slugify'
global.Avatar = require 'vue-avatar'

# Models
require './models/contact.coffee'
require './models/contact_group.coffee'
require './models/contact_event.coffee'
require './models/company.coffee'
require './models/account_setting.coffee'
require './models/flow.coffee'
require './models/flow_action.coffee'
require './models/flow_recipient.coffee'
require './models/template.coffee'
require './models/user.coffee'
require './models/tag.coffee'
require './models/task.coffee'
require './models/template.coffee'
require './models/contact_specific_template.coffee'
require './models/template_category.coffee'
require './models/email_statistic.coffee'
require './models/variable.coffee'
require './models/pipedrive_setting.coffee'
require './models/cv_crm_setting.coffee'
require './models/nectar_setting.coffee'
require './models/webhook_setting.coffee'
require './models/salesforce_setting.coffee'
require './models/rd_station_setting.coffee'
require './models/rd_station_crm_setting.coffee'
require './models/crm_setting.coffee'
require './models/plivo_setting.coffee'
require './models/twilio_setting.coffee'
require './models/voip_monthly_plan.coffee'
require './models/voip_additional_time.coffee'
require './models/nylas_setting.coffee'
require './models/carousel.coffee'
require './models/carousel_user.coffee'
require './models/custom_field.coffee'
require './models/contact_custom_field.coffee'
require './models/voip_call.coffee'
require './models/notification.coffee'
require './models/business.coffee'
require './models/vtiger_setting.coffee'
require './models/hubspot_setting.coffee'
require './models/lost_reason.coffee'
require './models/sharpspring_setting.coffee'
require './models/leadlovers_setting.coffee'
require './models/meeting_type.coffee'

# Resources
require './resources/base.coffee'
require './resources/contacts.coffee'
require './resources/contact_groups.coffee'
require './resources/contact_events.coffee'
require './resources/contact_tasks.coffee'
require './resources/flows.coffee'
require './resources/integrations.coffee'
require './resources/users.coffee'
require './resources/tags.coffee'
require './resources/tasks.coffee'
require './resources/templates.coffee'
require './resources/contact_specific_templates.coffee'
require './resources/template_categories.coffee'
require './resources/companies.coffee'
require './resources/variables.coffee'
require './resources/reports.coffee'
require './resources/carousel.coffee'
require './resources/carousel_property.coffee'
require './resources/comment_events.coffee'
require './resources/custom_fields.coffee'
require './resources/voip_calls.coffee'
require './resources/notifications.coffee'
require './resources/businesses.coffee'
require './resources/lost_reasons.coffee'
require './resources/meeting_types.coffee'

# Libraries
require './libraries/session.coffee'
require './libraries/action_cable.coffee'



// WEBPACK FOOTER //
// ./src/globals.coffee